import { render, staticRenderFns } from "./add-purchase.vue?vue&type=template&id=8cb94058"
import script from "./add-purchase.js?vue&type=script&lang=js&external"
export * from "./add-purchase.js?vue&type=script&lang=js&external"
import style0 from "./add-purchase.vue?vue&type=style&index=0&id=8cb94058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports